if (!customElements.get('prime-store-location')) {
    customElements.define(
      'prime-store-location',
      class extends HTMLElement {
        connectedCallback() {
          if (
            this.dataset.animate !== 'true' ||
            matchMedia(
              '(prefers-reduced-motion: reduce)'
            ).matches ||
            !('IntersectionObserver' in window)
          ) {
            return;
          }
          const items =
            this.querySelectorAll(
              '[data-location-reveal]'
            );
          this.observer =
            new IntersectionObserver(
              entries => {
                entries.forEach(
                  (entry, index) => {
                    if (!entry.isIntersecting) {
                      return;
                    }
                    entry.target.style.setProperty(
                      '--sl-delay',
                      `${Math.min(index, 4) * 70}ms`
                    );
                    entry.target.classList.add(
                      'is-location-visible'
                    );
                    this.observer.unobserve(
                      entry.target
                    );
                  }
                );
              },
              {
                threshold: 0.08
              }
            );
          items.forEach(
            item =>
              this.observer.observe(item)
          );
        }
        disconnectedCallback() {
          this.observer?.disconnect();
        }
      }
    );
  }